module.exports = __webpack_public_path__ + "img/icon_pesanan_black.33dfd8e4.png";